<script>
import moment from "moment";
import axios from '@/utils/axios';
import { allUsers } from '@/utils/user';
import "daterangepicker/daterangepicker.js";
import "daterangepicker/daterangepicker.css";
import DateRangePicker from "daterangepicker";
import payment_methods from '@/assets/json/payment-methods';
import { Modal } from 'bootstrap';

export default {
  inject: ['setLoading'],
  data() {
    return {
      title: "Finance & Accounts",
      text: "Finance & Accounts",
      editBalanceId: null,
      editBalance: '',
      data: [],
      pagination: {
       current_page: 1,
       per_page: 25,
       last_page: 1,
       total: 0,
       links: []
      },
      filter: {
       search: '',
       from_date: '',
       to_date: ''
      },
      loading: false,
      selectedLogs: [],
      selectedCustomer: ''
    };
  },

  computed: {
   text1(){
    return `Zoho Payments (${this.pagination.total})`;
   }, 
   serialNo(){
    return (this.pagination.current_page - 1) * this.pagination.per_page;
   } 
  },

  mounted(){
   this.zohoPayments();

   const start = moment().subtract(29, "days");
   const end = moment();

    new DateRangePicker(
      this.$refs.dateRangeInput,
      {
        startDate: start,
        endDate: end,
        locale: {
         format: "DD/MM/YYYY",
         separator: " - "
        },
        ranges: {
          Today: [moment(), moment()],
          Yesterday: [moment().subtract(1, "days"), moment().subtract(1, "days")],
          "Last 7 Days": [moment().subtract(6, "days"), moment()],
          "Last 30 Days": [moment().subtract(29, "days"), moment()],
          "This Month": [moment().startOf("month"), moment().endOf("month")],
          "Last Month": [
            moment().subtract(1, "month").startOf("month"),
            moment().subtract(1, "month").endOf("month"),
          ],
        }
      },
      (start, end) => {
        this.setDateRange(start, end);
      },
      this.booking_range
    );
    this.setDateRange(start, end);
  }, 

  methods: {

    openEditBalance(row) {
  this.editBalanceId = row.id;
  this.editBalance = row.balance;
  this.$nextTick(() => {
    const modal = new Modal(document.getElementById('editBalanceModal'));
    modal.show();
  });
},

async updateBalance() {
  this.setLoading(true);
  try {
    const response = await axios.patch(`/zoho-payments/${this.editBalanceId}/update-balance`, {
      balance: this.editBalance
    });
    this.$swalToast(response.data.message || 'Balance updated!', 'success');
    const modal = Modal.getInstance(document.getElementById('editBalanceModal'));
    modal.hide();
    this.zohoPayments();
  } catch (error) {
    this.$swalToast(error.message, 'error');
  } finally {
    this.setLoading(false);
  }
},

    booking_range(start, end) {
     return start.format("DD/MM/YYYY") + " - " + end.format("DD/MM/YYYY");
    },

    setDateRange(start, end) {
     this.filter.from_date = start.format("YYYY-MM-DD");
     this.filter.to_date = end.format("YYYY-MM-DD");
    },

    async zohoPayments(page = 1) {
     this.setLoading(true);
     try{
      const params = {
       page,
       per_page: this.pagination.per_page,
       user_id: this.filter.user || '',
       from_date: this.filter.from_date,
       to_date: this.filter.to_date,
       search: this.filter.search.trim() || ''
      };
      const query_string = new URLSearchParams(params).toString();
      const response = await axios.get(`/zoho-payments?${query_string}`);
      this.data = response.data.data.data;
      this.pagination = {
        current_page: response.data.data.current_page,
        per_page: response.data.data.per_page,
        last_page: response.data.data.last_page,
        total: response.data.data.total,
        links: response.data.data.links
      };
     }catch(error){
      this.$swalToast(error.message, 'error');
     }finally{
      this.setLoading(false);
     }
    },

    changePage(url){
     if (!url) return;
     const page = new URL(url).searchParams.get("page");
     this.zohoPayments(page);
    },

   clearFilter(){
    this.filter.user = null;
    this.filter.search = '';
    this.zohoPayments();
   },

   showFollowUpLogs(row) {
    this.selectedLogs = row.follow_up_logs || [];
    this.selectedCustomer = row?.customer?.name || '';
    this.$nextTick(() => {
      const modal = new Modal(document.getElementById('followUpLogsModal'));
      modal.show();
    });
   },
    
  },
};
</script>

<template>
<layout-header></layout-header>
<layout-sidebar></layout-sidebar>

<!-- Page Wrapper -->
<div class="page-wrapper">
  <div class="content">
    <!-- Breadcrumb -->
    <div class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
      <breadcrumb :title="title" :text="text" :text1="text1" />
      <div class="d-flex my-xl-auto right-content align-items-center flex-wrap">
        
        <div class="me-2 mb-2">
          <router-link to="/finance-accounts/zoho-payments/import/csv" class="btn btn-primary d-flex align-items-center">
            <i class="ti ti-file-type-csv me-1"></i>Import from CSV
          </router-link>
        </div>
        
        <div class="mb-2">
          <router-link :to="{name: 'zoho-payment-history'}" class="btn btn-warning d-flex align-items-center">
            <i class="ti ti-history me-2"></i>Uploader History
          </router-link>
        </div>
       
      </div>
    </div>
    <!-- /Breadcrumb -->

    <div class="card">
      <div class="card-header d-flex align-items-center justify-content-center flex-wrap row-gap-3">
        
        <div class="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
        
          <div class="me-1" v-if="filter.search !== ''">
            <a href="javascript:void(0);" class="text-danger" @click="clearFilter()">
              <i class="ti ti-filter-x"></i>
            </a>
          </div>  

          <div class="me-3">
            <div class="input-icon-end position-relative">
              <input type="text" class="form-control date-range bookingrange" ref="dateRangeInput" placeholder="dd/mm/yyyy - dd/mm/yyyy">
              <span class="input-icon-addon"><i class="ti ti-chevron-down"></i></span>
            </div>
          </div>

          <div class="me-3">
            <div class="input-icon-end position-relative">
              <input type="text" class="form-control" v-model="filter.search" placeholder="Search...."/>
            </div>
          </div>

          <div class="">
            <button type="button" class="btn btn-dark" @click="zohoPayments()">
              <i class="ti ti-search"></i>
            </button>
          </div>

        </div>
        
      </div>

      <div class="card-body card-table-wrapper">
        <div class="custom-datatable-filter table-responsive" v-if="data?.length">
          <table class="card-table">
            <thead>
              <tr>
                <th>#</th>
                <th>Invoice Date</th>
                <th>Invoice No</th>
                <th>Client</th>
                <th>Balance</th>
                <th>Follow Up Logs</th>
                <th>Uploaded At</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, index) in data" :key="row.id">
                <td>{{ serialNo + index + 1 }}.</td>  
                <td>{{ $formatDate(row.invoice_date, 'DD-MM-YYYY') }}</td>
                <td>{{ row.invoice_number }}</td>
                <td>
                  <a :href="`/crm/customers-details/${row?.customer?.id}`" target="_blank">
                    {{ row?.customer?.name }}
                  </a>
                </td>
                <td>
                  {{ row.balance }}
                  <a href="javascript:void(0);" class="ms-2 text-primary" @click="openEditBalance(row)">
                    <i class="ti ti-edit" style="font-size:13px;"></i>
                  </a>
                </td>
                <td>
                  <span
                    v-if="row.follow_up_logs && row.follow_up_logs.length"
                    class="badge bg-primary"
                    style="cursor: pointer;"
                    @click="showFollowUpLogs(row)"
                  >
                    <i class="ti ti-eye me-1"></i>{{ row.follow_up_logs.length }} Logs
                  </span>
                  <span v-else class="text-muted">—</span>
                </td>
                <td>{{ $formatDate(row.created_at, 'DD-MM-YYYY') }}</td>
              </tr>
            </tbody>
          </table>

          <!-- Pagination -->
          <nav v-if="pagination.links.length > 3" class="mt-2 margin-l-2">
            <ul class="pagination pagination-sm">
              <li v-for="(link, index) in pagination.links" :key="index" :class="['page-item', { active: link.active, disabled: !link.url }]">
                <a class="page-link" href="javascript:void(0)" v-html="link.label" @click="changePage(link.url)"></a>
              </li>
            </ul>
          </nav>

        </div>

        <div v-else class="p-3 text-center text-muted">No records found.</div>
        
      </div>
    </div>
  </div>

  <app-footer></app-footer>

</div>
<!-- /Page Wrapper -->

<!-- Follow Up Logs Modal -->
<div class="modal fade" id="followUpLogsModal" tabindex="-1" aria-labelledby="followUpLogsModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">

      <div class="modal-header">
        <h5 class="modal-title" id="followUpLogsModalLabel">
          <i class="ti ti-history me-2"></i>Follow Up Logs — {{ selectedCustomer }}
        </h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>

      <div class="modal-body p-0">
        <div class="table-responsive">
          <table class="table table-bordered table-striped mb-0">
            <thead class="thead-light">
              <tr>
                <th>#</th>
                <th>Template</th>
                <th>Status</th>
                <th>Sent At</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(log, index) in selectedLogs" :key="log.id">
                <td>{{ index + 1 }}</td>
                <td>
                  <span class="fw-semibold">{{ log.template?.name || '—' }}</span>
                  <br>
                  <small class="text-muted">{{ log.template?.code || '' }}</small>
                </td>
                <td>
                  <span
                    class="badge"
                    :class="{
                      'bg-success': log.status === 'sent',
                      'bg-danger': log.status === 'failed',
                      'bg-warning text-dark': log.status === 'pending'
                    }"
                  >
                    {{ log.status }}
                  </span>
                </td>
                <td>{{ $formatDate(log.sent_at, 'DD-MM-YYYY HH:mm') }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
      </div>

    </div>
  </div>
</div>
<!-- /Follow Up Logs Modal -->

<!-- Edit Balance Modal -->
<div class="modal fade" id="editBalanceModal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-sm">
    <div class="modal-content">

      <div class="modal-header">
        <h5 class="modal-title">
          <i class="ti ti-pencil me-2"></i>Update Balance
        </h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>

      <div class="modal-body">
        <label class="form-label fw-semibold">Balance</label>
        <input 
          type="number" 
          class="form-control" 
          v-model="editBalance" 
          placeholder="Enter balance" 
        />
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-light" data-bs-dismiss="modal">Cancel</button>
        <button type="button" class="btn btn-primary" @click="updateBalance">
          <i class="ti ti-device-floppy me-1"></i>Update
        </button>
      </div>

    </div>
  </div>
</div>
<!-- /Edit Balance Modal -->

</template>